import React from "react"
import PropTypes from "prop-types"

import Input from "../molecules/Input"
import Grid from "../organisms/Grid"

class Form extends React.Component {
  render() {
    return (
      <form
        name={this.props.name}
        method="POST"
        netlify-honeypot="mad_skillz"
        netlify="true"
      >
        <input type="hidden" name="form-name" value={this.props.name} />

        <Grid type="rows">
          <Input
            label="Don't fill this in."
            name="mad_skillz"
            type="honeypot"
          />
          {this.props.children}
        </Grid>
      </form>
    )
  }
}

Form.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Form
